import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import NavMenu from '../../../components/NavMenu';
import { NavMenyItem } from '../../../components/NavMenu/types';
import ContentContainter from '../../../templates/Content/ContentContainer';

import LogsPage from './Pages/EmailLogs';
import ConfigPage from './Pages/EmailSmtpConfig';
import SendEmail from './Pages/SendEmail';

const EmailTSX = () => {
  const { t } = useTranslation();
  const [tabSelected, setTabSelected] = useState({
    value: 'logs',
    name: 'logs',
  });

  const navMenuItems: NavMenyItem[] = [
    {
      title: t('logs'),
      action: () =>
        setTabSelected({
          value: 'logs',
          name: 'logs',
        }),
    },
    {
      title: t('smtpConfig'),
      action: () =>
        setTabSelected({
          value: 'smtpConfig',
          name: 'smtpConfig',
        }),
    },
    {
      title: t('sendEmail'),
      action: () =>
        setTabSelected({
          value: 'sendEmail',
          name: 'sendEmail',
        }),
    },
  ];

  const handleViewPag = (pagName: string) => {
    let pageSelected = <LogsPage />;

    switch (pagName) {
      case 'logs':
        pageSelected = <LogsPage />;
        break;
      case 'smtpConfig':
        pageSelected = <ConfigPage />;
        break;
      case 'sendEmail':
        pageSelected = <SendEmail />;
        break;
      default:
        pageSelected = <LogsPage />;
        break;
    }

    return pageSelected;
  };

  return (
    <ContentContainter title={t(tabSelected.value)}>
      <NavMenu items={navMenuItems} />

      {handleViewPag(tabSelected.value)}
    </ContentContainter>
  );
};

export default EmailTSX;
